export type BsArmDir = 'S' | 'I' | 'N' | 'T';

export interface StudyConfig {
  studyKey: string;
  // Design + test only the study eye (applies to BOTH 'localizer' and 'home' wizard modes).
  studyEyeOnly: boolean;
  // Fellow-eye registration/foveal-pit retained for the fixation-laterality judgement;
  // design/test steps remain study-eye-only. Only consulted when studyEyeOnly is true.
  registerNonStudyEye: boolean;
  // Home BS arms: one arm per axis, designer may swap default<->alt independently.
  // null = legacy/SIENNA behavior (fixed BS-N + BS-T, no selector UI).
  homeBsArms: null | {
    vertical: { default: BsArmDir; alt: BsArmDir };
    horizontal: { default: BsArmDir; alt: BsArmDir };
  };
  // 'choose' keeps the FixationOption step; 'binocular'/'monocular' skip the step and fix the value.
  fixationMode: 'choose' | 'binocular' | 'monocular';
}

export const studyConfig: StudyConfig = {
  studyKey: 'DFI18231',
  studyEyeOnly: true,
  // fellow-eye registration/foveal-pit retained for the fixation-laterality judgement;
  // design/test steps remain study-eye-only
  registerNonStudyEye: true,
  homeBsArms: {
    vertical: { default: 'S', alt: 'I' },
    horizontal: { default: 'N', alt: 'T' },
  },
  fixationMode: 'choose',
};

// The two `BS-${dir}` group ids NOT currently chosen (one per axis).
// Empty when homeBsArms is null (legacy behavior has no arm choice).
export function getUnchosenBsArmGroups(choice: { vertical: BsArmDir; horizontal: BsArmDir }): string[] {
  const arms = studyConfig.homeBsArms;
  if (!arms)
    return [];
  const v = choice.vertical === arms.vertical.default ? arms.vertical.alt : arms.vertical.default;
  const h = choice.horizontal === arms.horizontal.default ? arms.horizontal.alt : arms.horizontal.default;
  return [`BS-${v}`, `BS-${h}`];
}
